import { render, staticRenderFns } from "./SubscriptionStatus.vue?vue&type=template&id=484bf594&"
import script from "./SubscriptionStatus.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports